// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-bg {
  background: radial-gradient(circle at center, #1e1e1e, #000);
  overflow: hidden;
  position: relative;
}

.welcome-bg::before {
  content: '';
  position: absolute;
  width: 400%;
  height: 400%;
  top: -150%;
  left: -150%;
  background: repeating-radial-gradient(circle, rgba(255,255,255,0.05), transparent 100px);
  animation: glowStars 30s linear infinite;
}

@keyframes glowStars {
  from {
    transform: rotate(0deg) scale(1);
  }
  to {
    transform: rotate(360deg) scale(1.1);
  }
}

.diamond-loader {
  width: 60px;
  height: 60px;
  background-color: #00e5ff;
  transform: rotate(45deg);
  animation: pulse 1.8s ease-in-out infinite alternate, float 3s ease-in-out infinite;
  border-radius: 8px;
}

@keyframes pulse {
  0% { transform: rotate(45deg) scale(1); }
  100% { transform: rotate(45deg) scale(1.2); }
}

@keyframes float {
  0%, 100% { transform: rotate(45deg) translateY(0); }
  50% { transform: rotate(45deg) translateY(-10px); }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Welcome.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,wFAAwF;EACxF,wCAAwC;AAC1C;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,mFAAmF;EACnF,kBAAkB;AACpB;;AAEA;EACE,KAAK,iCAAiC,EAAE;EACxC,OAAO,mCAAmC,EAAE;AAC9C;;AAEA;EACE,WAAW,sCAAsC,EAAE;EACnD,MAAM,0CAA0C,EAAE;AACpD","sourcesContent":[".welcome-bg {\r\n  background: radial-gradient(circle at center, #1e1e1e, #000);\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.welcome-bg::before {\r\n  content: '';\r\n  position: absolute;\r\n  width: 400%;\r\n  height: 400%;\r\n  top: -150%;\r\n  left: -150%;\r\n  background: repeating-radial-gradient(circle, rgba(255,255,255,0.05), transparent 100px);\r\n  animation: glowStars 30s linear infinite;\r\n}\r\n\r\n@keyframes glowStars {\r\n  from {\r\n    transform: rotate(0deg) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(360deg) scale(1.1);\r\n  }\r\n}\r\n\r\n.diamond-loader {\r\n  width: 60px;\r\n  height: 60px;\r\n  background-color: #00e5ff;\r\n  transform: rotate(45deg);\r\n  animation: pulse 1.8s ease-in-out infinite alternate, float 3s ease-in-out infinite;\r\n  border-radius: 8px;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { transform: rotate(45deg) scale(1); }\r\n  100% { transform: rotate(45deg) scale(1.2); }\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% { transform: rotate(45deg) translateY(0); }\r\n  50% { transform: rotate(45deg) translateY(-10px); }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
